import { PageProductsContextProvider } from '@app/components/pages/context/PageProductsContext';
import { getBuyerIdFromCurrentOrder, getIsSeller } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { PageContent } from './CmsPageContent';

export const CmsPage = () => {
  const { id, pageSlug } = useParams<{ id: string; pageSlug: string }>();
  const isSeller = useSelector(getIsSeller);
  const orderBuyerId = useSelector(getBuyerIdFromCurrentOrder);
  const buyerId = isSeller ? orderBuyerId : undefined;

  if (!isDefined(id) || !isDefined(pageSlug)) {
    return null;
  }

  return (
    <PageProductsContextProvider buyerId={buyerId}>
      <PageContent pageSlug={pageSlug} orderId={id} />
    </PageProductsContextProvider>
  );
};
